module.exports = __webpack_public_path__ + "static/media/5-rectangle-occupied.5e15eec9.svg";